import React, { useState } from 'react';
import Chart from './Chart';

const Tab = ({ label, isActive, onClick }) => (
    <button
        onClick={onClick}
        className={`px-4 py-2 border-b-2 text-sm font-medium transition ${isActive
            ? 'border-blue-600 text-blue-600'
            : 'border-transparent text-gray-500 hover:text-blue-600 hover:border-blue-300'
            }`}
    >
        {label}
    </button>
);

export const Tabs = ({
    description,
    attributes,
    values,
    historyValues,
    historyLabels,
}) => {
    const [activeTab, setActiveTab] = useState('overview');

    return (
        <div className="">
            {/* Tab Headers */}
            <div className="flex space-x-4 border-b mb-4">
                <Tab label="Overview" isActive={activeTab === 'overview'} onClick={() => setActiveTab('overview')} />
                {Object.keys(values).length > 0 ? (
                    <Tab label="Specifications" isActive={activeTab === 'specs'} onClick={() => setActiveTab('specs')} />
                ) : null}

                <Tab label="Price history" isActive={activeTab === 'history'} onClick={() => setActiveTab('history')} />
                {/* <Tab label="Pricing" isActive={activeTab === 'pricing'} onClick={() => setActiveTab('pricing')} /> */}
            </div>

            {/* Tab Content */}
            <div className="text-gray-700">
                {activeTab === 'overview' ? (
                    description
                ) : null}
                {activeTab === 'specs' ? (
                    // <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10">
                    <div className="flex flex-col [&>*:nth-child(odd)]:bg-gray-100">
                        {attributes ? attributes.map((attribute) => {
                            if (values.hasOwnProperty(attribute.id) === false) {
                                return
                            }

                            return (
                                // <div className="bg-gray-100 p-4 rounded-xl shadow text-sm">
                                //     <p className="font-semibold mb-1">{attribute.name}</p>
                                //     <p>{values[attribute.id]}</p>
                                // </div>
                                <div className="flex p-2">
                                    <div className='w-1/2 lg:w-1/4'>
                                        {attribute.name}
                                    </div>
                                    <div className='w-1/2 lg:w-3/4'>
                                        {values[attribute.id]}
                                    </div>
                                </div>
                            )
                        }) : null}
                    </div>
                ) : null}
                {activeTab === 'history' ? (
                    <Chart values={historyValues} labels={historyLabels} />
                ) : null}
                {/* {activeTab === 'pricing' && <p>Compare prices from different stores here.</p>} */}
            </div>
        </div>
    );
};